import React from 'react';

type LogoVariant = 'light' | 'dark' | 'mark' | 'app-icon';

interface LogoProps {
  variant?: LogoVariant;
  className?: string;
  alt?: string;
}

const SRC: Record<LogoVariant, string> = {
  light: '/logo-light.png',
  dark: '/logo-dark.png',
  mark: '/logo-mark.png',
  'app-icon': '/app-icon.png',
};

const Logo: React.FC<LogoProps> = ({ variant = 'light', className = '', alt = 'Sportofolo' }) => (
  <img src={SRC[variant]} alt={alt} className={className} draggable={false} />
);

export default Logo;
